<template>
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
<path d="M4.5 11.25L9 6.75L13.5 11.25" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>